import { createContext } from "react";
import { AuthContextType } from "../../types/auth";

/**
 * Enhanced authentication context with additional MFA functionality
 */

// Create auth context with default values
const AuthContext = createContext<AuthContextType>({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  isInitialized: false,
  requiresMfa: false,
  mfaEmail: null,
  mfaSessionExpiry: null,
  error: null,
  login: async () => {},
  verifyMfa: async () => {},
  resendMfaCode: async () => {},
  logout: async () => {},
  resetPasswordRequest: async () => {},
  resetPassword: async () => {},
  changePassword: async () => {},
  clearError: () => {},
  refreshUser: async () => {},
});

export default AuthContext;
